import { render, staticRenderFns } from "./ActivationEmailsEmptyState.vue?vue&type=template&id=644096a4&scoped=true&"
import script from "./ActivationEmailsEmptyState.vue?vue&type=script&lang=ts&"
export * from "./ActivationEmailsEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./ActivationEmailsEmptyState.vue?vue&type=style&index=0&id=644096a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644096a4",
  null
  
)

export default component.exports